/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { HelpBugRequestBusinessService } from '../../resources';
import { HelpBugRequestDialogComponent } from './bug-request-dialog.component';

export const helpBugRequestDialog = createDialogRoute({
  component: HelpBugRequestDialogComponent,
  init: HelpBugRequestBusinessService,
  config: { disableClose: true },
});
